<template>
    <v-select
        :value="select_station"
        @change="changeStation"
        :items="select_station_items"
        item-text="station_name"
        item-value="station_code"
        :label="$t('station')"
        return-object
        outlined
        dense
        :solo="!have_label"
    ></v-select>
</template>


<script>
    export default {
        props: {station_code:[String, Number],have_label: {type: Boolean,required: false,default: true}},
        data: () => ({
            select_station : {station_name:"",station_code:""},
            select_station_items : [],
        }),
        mounted : function () {
            this.$store.getters.getStationList
            .then(result=>{
                this.select_station_items = result
                this.select_station = result.filter(s=>this.station_code==s.station_code)[0]
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        methods: {
            changeStation(station){
                this.$emit('onchange',station);
                //document.location = station.station_code
            }
        }
    }
</script>